module.exports = __webpack_public_path__ + "static/media/avatars_female_10.b04ac492.png";